// extracted by mini-css-extract-plugin
export default {"triangle":"Triangle_triangle__sEYNt","text":"Triangle_text__jqRQ3"};